import React from 'react';
import { Seed } from './Seed';
const coverage = [{
  label: 'The Wind Check',
  body: 'Three questions at the dock that pick today’s version in about two minutes'
}, {
  label: 'Setup with a diagram',
  body: 'Marks, cones and gear, plus a top-down course diagram with the wind arrow'
}, {
  label: 'Dock brief in 3 cues',
  body: 'Exactly what to say before launch, short enough that the group remembers it'
}, {
  label: 'Watch for · error → fix',
  body: 'What to look for on the water, the most common mistake and the cue that fixes it'
}, {
  label: 'Easier / Harder',
  body: 'How to dial the same lesson down for nervous sailors or up for the ones who are ready'
}, {
  label: 'Safety Note',
  body: 'The safety rule for that lesson, pointing back to your own program’s limits and ratios'
}];
const versions = [{
  name: 'Light Air',
  time: 'Drift drills, tows, on-the-spot versions',
  tone: 'bg-sage-soft text-sage-deep'
}, {
  name: 'Right Air',
  time: 'The full on-the-water plan',
  tone: 'bg-sky-soft text-sky-deep'
}, {
  name: 'Wrong Air',
  time: 'Dock, shore, indoor or protected water',
  tone: 'bg-rose-soft text-rose-deep'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="relative w-full overflow-hidden bg-white" data-id="element-194" data-mp="1jt9903k14whc">
      <Seed className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 opacity-20" data-id="element-195" data-mp="1os2qs86cn9nb" />
      <div className="relative mx-auto max-w-5xl px-5 py-16 text-center sm:py-20" data-id="element-196" data-mp="s238vn4b6ys2">
        <p className="text-sm font-semibold text-teal-deep" data-id="element-197" data-mp="s4fxuk8hi9em">The method</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-198" data-mp="w46u33gs5hqj">
          The Any-Wind Lesson System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-navy-soft sm:text-lg" data-id="element-199" data-mp="161l1yeon0y78">
          Instead of one plan that only works in good wind, every lesson in
          the pack is a one-page{' '}
          <span className="font-semibold text-navy" data-id="element-200" data-mp="2hgri5fhls0lv">Lesson Card</span> written
          in three versions with the same learning goal. You look at the wind
          in the morning, open the version that fits and teach it. The day
          goes ahead with a plan,{' '}
          <span className="font-semibold text-navy" data-id="element-201" data-mp="1mvvmjunntomo">on the water or on shore</span>.
        </p>

        <ol className="mx-auto mt-9 grid max-w-3xl gap-3 sm:grid-cols-3" data-id="element-202" data-mp="21oz78awjsihm">
          {versions.map((v, i) => <li key={v.name} className={`rounded-2xl px-4 py-4 ${v.tone}`} data-id="element-203" data-mp="1wq4fukkilllw" data-mpi={i}>
              <span className="block text-xs font-bold opacity-80" data-id="element-204" data-mp="192nxa9n1x585">Version {i + 1}</span>
              <span className="mt-1 block font-display text-xl" data-id="element-205" data-mp="144ur3glr0b7v">{v.name}</span>
              <span className="mt-0.5 block text-xs font-semibold opacity-80" data-id="element-206" data-mp="1it92wh157a0k">{v.time}</span>
            </li>)}
        </ol>
        <p className="mt-3 text-xs text-navy-muted" data-id="element-207" data-mp="1e06865kmpuis">
          Wrong Air is for when the wind or rain is past your program’s limits. The pack never sets a wind limit: your program does.
        </p>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="lcjuu5llnbiq">
          {coverage.map(item => <li key={item.label} className="rounded-2xl bg-paper px-4 py-3.5 ring-1 ring-paper-dark" data-id="element-209" data-mp="31qvlc8zqtjll">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-210" data-mp="2n1zhko4pysqs">{item.label}</span>
              <span className="mt-1 block text-sm text-navy" data-id="element-211" data-mp="2n04up49w0qk2">{item.body}</span>
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-2xl text-sm text-navy-soft" data-id="element-212" data-mp="3fqwmzqnu0v24">
          Every session follows the same Dock-to-Debrief formula, from Wind
          Check to Debrief, in 60-minute, 90-minute and half-day versions.
        </p>
      </div>
    </section>;
}